const TabPanels = ({ children, className = "", ...rest }) => {
  return (
    <div className={`tabs-panels ${className}`} {...rest}>
      {children}
    </div>
  );
};

export default TabPanels;
